import success from '@/assets/images/icon_success.png'

const Toast = (text: number | string, icon?, time = 1.5) => {
    if (!text) {
        return
    }
    let toastTimeout: ReturnType<typeof setTimeout> | null = null; // 用于存储定时器的引用
    // 销毁定时器
    if (toastTimeout) {
        clearTimeout(toastTimeout);
    }

    // 检查是否存在现有的提示框，如果存在则移除
    const successToast = document.querySelector('.success_toast');
    if (successToast) {
        successToast.remove();
    }

    // 创建容器
    const div: HTMLDivElement = document.createElement('div')
    div.className = "success_toast"
    // 创建二级容器
    const toastContainer: HTMLDivElement = document.createElement('div')
    toastContainer.className = "success_toast_container"
    // 创建img
    // 创建i标签用于loading动画
    if (icon === 'loading') {
        const i = document.createElement('i')
        i.className = 'iconfont loading icon-icon_loading'
        i.style.color = 'white'
        toastContainer.appendChild(i)
    } else if (icon) {
        if (icon === 'success') {
            icon = success
            const img = document.createElement('img')
            img.src = icon
            img.className = 'success_toast_icon'
            toastContainer.appendChild(img)
        } else if (icon === 'fail') {
            const i = document.createElement('i')
            i.className = 'iconfont icon-icon_cancel'
            i.style.color = 'white'
            toastContainer.appendChild(i)
        }
        
    }
    //创建文本span
    const span = document.createElement('div')
    span.className = 'success_toast_text'
    span.innerHTML = text as string
    toastContainer.appendChild(span)
    div.appendChild(toastContainer)

    document.body.appendChild(div)
    toastTimeout = setTimeout(() => {
        div.remove()
    }, time * 1500)
}

export default Toast
